<script>
export default {
    name: "weekdays-setting",
    props: {
        disabled: Boolean,
        value: {}
    },
    computed: {
        label() {
            return Lang.langGet("Skip weekdays");
        },
        items() {
            return [
                {
                    text: Lang.langGet("Monday"),
                    value: 'pdMonday'
                },
                {
                    text: Lang.langGet("Tuesday"),
                    value: 'pdTuesday'
                },
                {
                    text: Lang.langGet("Wednesday"),
                    value: 'pdWednesday'
                },
                {
                    text: Lang.langGet("Thursday"),
                    value: 'pdThursday'
                },
                {
                    text: Lang.langGet("Friday"),
                    value: 'pdFriday'
                },
                {
                    text: Lang.langGet("Saturday"),
                    value: 'pdSaturday'
                },
                {
                    text: Lang.langGet("Sunday"),
                    value: 'pdSunday'
                }
            ];
        },
    }
}
</script>

<template>
    <v-autocomplete-custom
        :value="value"
        @input="$emit('input', $event)"
        :label="label"
        :disabled="disabled"
        :items="items"
        multiple
    />
</template>

